module.exports = __webpack_public_path__ + "img/logo.0198deb3.png";